<template>
<div class="chapter">
<div class="inner_page">
<div class="_idGenObjectStyleOverride-1">
<p class="Graphic-L"><img alt="" class="_idGenObjectAttribute-2" role="presentation" src="image/ISAACS-collage-01.jpg"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 9781035845781_EPUB1.vue?27863f8c